import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {map, tap} from "rxjs/operators";

const getSessionValue = environment.apiUrl + 'Value/File/--projectShortName--/--tokenIdentifier--/--sessionId--';
@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(
    private http: HttpClient
  ) { }

  getFiles(
    projectShortName: string,
    tokenIdentifier: string,
    sessionId: string
  ) {
    const parsingUrl = getSessionValue.replace('--projectShortName--', projectShortName)
      .replace('--tokenIdentifier--', tokenIdentifier)
      .replace('--sessionId--', sessionId);

      return this.http.get<any>(parsingUrl).pipe(
        tap(res => res),
        map(res => res)
      );
  }
}
